// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"727":"aa6724ec6820b3bea376","879":"c6fd8246f2e40c03c039"}[chunkId] + ".js";
};